import coinRating from '../widgets/coinRating.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await coinRating.updateDynamicsData();
    });
}(jQuery));